/**
 * @description 图表组件=>去除图形,展示班级信息title组件 2021-1-5 
 * @author xyguo
 * @date 2020-3-6
 */
import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'dva'
import { modelUtils } from '../../../../utils'
import ClassResultPercent  from './classResultPercent'
import { component_tool, framework_tool, utils_tool } from '@/tool'
let {
  WizCard,
  WizBizcharts
} = component_tool;
let { WizContainer } = framework_tool;

class ResultCharts extends WizContainer {

    componentName = 'ResultCharts';

    constructor(props){
        super(props);
        this.state={
          chartsData:undefined
        }
      }

    _componentDidMount() {
        this._getData()
    }

    _getData(other = {}) {
        this.doAction({
            path: `classResult/getListInfo`,
            payload: {
              key: `classResult@getListInfo`,
              apiParams: {classInfoId:this.props.classInfoId} //this._record.id
            }
        });
      };

    state = {
    };

    propsAndStateOnChange = {
        gradeCharts: this._gradeChartsOver.bind(this)
      }

    _gradeChartsOver(nextProps, nextState) {
        let data = [];
        if (nextProps.gradeCharts.code === 1) {
          data = nextProps.gradeCharts.data;
          nextState.chartsData = Object.assign({},data);
          nextState.time = new Date().getTime();
          return true;
        } else {
          //wizNotice.error('图表数据获取失败！！');
          wizNotice.error('班级基础数据获取失败！！');
          return false;
        }
      }

    _render() {
      let titles = ['班级名称','班级时间','讲师'];
      let values = this.state.chartsData ?[
            this.state.chartsData.className,
            this.state.chartsData.classStartDate+'-'+this.state.chartsData.classEndDate,
            this.state.chartsData.lectureName]
            :['','',''];
      let resultPrecent = this.state.chartsData ? <ClassResultPercent key={new Date().getTime()+'_classResultPercent'}
      headerProps={{ title: titles, value: values}}
      percentProps={{
        data: [
          {
            item: "通过人数",
            count: this.state.chartsData.passCount < 0 ? 0:this.state.chartsData.passCount,
          },
          {
            item: "未通过人数",
            count: this.state.chartsData.noPassCount < 0 ? 0:this.state.chartsData.noPassCount,
          },
          {
            item: "无成绩人数",
            count: this.state.chartsData.noResultCount < 0 ? 0:this.state.chartsData.noResultCount,
          },
          {
            item: "未输入人数",
            count: this.state.chartsData.noInputCount < 0 ? 0:this.state.chartsData.noInputCount,
          }
        ],
        dataFormat: {
          type: "percent",
          field: "count",
          dimension: "item",
          as: "percent"
        },
        count: this.state.chartsData.totalCount && this.state.chartsData.totalCount,
        centerText: '参训人数'
      }}
      itemProps={[
        // { img: constants.files.sys_main_logo, title: '最高分', value: this.state.chartsData?this.state.chartsData.maxScore < 0 ? '暂无':this.state.chartsData.maxScore:'暂无' + '分' },
        // { img: constants.files.sys_main_logo, title: '平均分', value: this.state.chartsData?this.state.chartsData.avgScore < 0 ? '暂无':this.state.chartsData.avgScore:'暂无' + '分'  },
        // { img: constants.files.sys_main_logo, title: '最低分', value: this.state.chartsData?this.state.chartsData.minScore < 0 ? '暂无':this.state.chartsData.minScore:'暂无' + '分'  }
      ]}
    /> : null;

        return [
            <WizCard title={'班级概况'} key={new Date().getTime()} bodyStyle={{paddingLeft:20,paddingBottom:0,paddingTop:25}}>
                {resultPrecent}
            </WizCard>
        ]
    }
}

const mapStateToProps = (state, ownProps) => {
    const { classResult } = state;
    const gradeCharts = modelUtils.getModelEntity(
        classResult,
      "classResult@getListInfo"
    );
    return {
        gradeCharts:gradeCharts,
    };
};

export default connect(mapStateToProps)(ResultCharts);
